<template>
  <div 
    class="meteo" 
  >
    <ItemMeteo 
    />
  </div>
</template>
<script>
import ItemMeteo from '@/views/public/mobile/customMenu/items/Meteo'
export default {
  components: {
    ItemMeteo
  },
  props: {
    enterprise: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    item: null, 
  }),
}
</script>
<style scope>
.meteo {
  height: 100%;
  overflow-y: scroll;
}
</style>

